import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Card, Table, Button, Spinner } from "react-bootstrap";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useLocation } from "react-router-dom";

export default function ReservationDetails() {
  const location = useLocation(); // to trigger re-render on route change
  const {reservation, API_BASE, token, branch, id} = location.state || {}; // get reservation data from route state
    const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const pdfRef = useRef();
 const LOGO_URL =
  "https://paupet-pub.s3.eu-north-1.amazonaws.com/Emerald-Logo-White.jpeg";
  
useEffect(() => {
  if (reservation) {
    setData(reservation);
  }

  if (!reservation) {
    const fetchData = async () => {
      if (!branch || !token) return; // ✅ FIXED

      const reservationRes = await axios.get(
        `${API_BASE}reservations/${id}`, // ✅ also fix URL
        {
          params: { branch },
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setData(reservationRes.data || []);
    };

    fetchData();
  }

  console.log("Fetched Reservation:", reservation, id, API_BASE, token, branch);
}, [reservation, API_BASE, token, branch, id]);// re-run when reservation changes
 

  const downloadPDF = async () => {
    const element = pdfRef.current;

    //const canvas = await html2canvas(element);
    const canvas = await html2canvas(element, {
  useCORS: true,
  allowTaint: true,
  scale: 2, // improves quality
});
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 210;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    pdf.save("reservation.pdf");
  };

  if (loading) return <Spinner />;

  if (!data) return <p>No Data</p>;
 
const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-IN");
};
  return (


<div>
  {/* PDF CONTENT */}
  <div
    ref={pdfRef}
    style={{
      padding: "20px",
      background: "#fff",
      width: "800px",
      margin: "auto",
    }}
  >
    <Card>
      <Card.Body>

        {/* HEADER */}
        <div className="text-center mb-3">
          <img src={LOGO_URL} alt="logo" style={{ height: 60 }}
          crossOrigin="anonymous"
          />
          <h3 className="mt-2">Emerald Suites</h3>
        </div>

        <p>Dear {data.guestName || "Guest"},</p>
        <p>
          Thank you for choosing Emerald Suites for your comfortable stay.
        </p>

        {/* RESERVATION DETAILS */}
        <Table bordered>
          <tbody>
            <tr>
              <td>Reservation Date</td>
              <td>{formatDate(data.reservationDate)}</td>
            </tr>

            <tr>
              <td>Reservation #</td>
              <td>{data.reservationId}</td>
            </tr>

            <tr>
              <td>Guest Name</td>
              <td>{data.guestName}</td>
            </tr>

            <tr>
              <td>Mobile</td>
              <td>{data.mobile}</td>
            </tr>

            <tr>
              <td>Email</td>
              <td>{data.email}</td>
            </tr>

            <tr>
              <td>Check-In</td>
              <td>{formatDate(data.checkInDate)}</td>
            </tr>

            <tr>
              <td>Check-Out</td>
              <td>{formatDate(data.checkOutDate)}</td>
            </tr>

            <tr>
              <td>Nights</td>
              <td>{data.nights}</td>
            </tr>

            

            <tr>
              <td>Room Type</td>
              <td>{data.roomType}</td>
            </tr>

            <tr>
              <td>Guests</td>
              <td>
                {data.adults} Adults, {data.children} Children
              </td>
            </tr>

            <tr>
              <td>Tariff / Night</td>
              <td>₹ {data.pricePerNight}</td>
            </tr>

               
            <tr>
              <td>Complementary</td>
              <td>Wifi</td>
            </tr>
   <tr>
              <td>Billing Instruction</td>
              <td>Direct</td>
            </tr>
           <tr className="table-danger">
  <td>Room</td>
  <td className="fw-bold">Non Smoking Rooms</td>
</tr>
            <tr>
              <td>Remarks</td>
              <td>{data.notes}</td>
            </tr>
            <tr>
              <td>Prepared by</td>
              <td>{data.preparedBy}</td>
            </tr>
          </tbody>
        </Table>

        {/* POLICY */}
        <h5>Cancellation Policy</h5>
        <ul>
          <li>No charges before 20 days</li>
          <li>50% refund between 15–7 days</li>
          <li>No refund within 2 days</li>
        </ul>

        {/* FOOTER */}
        <p className="text-center mt-4">
          We look forward to hosting you. Have a pleasant stay!
        </p>

      </Card.Body>
    </Card>
  </div>

  {/* ACTION */}
  <div className="mt-3 text-center">
    <Button variant="primary" onClick={downloadPDF}>
      Download PDF
    </Button>
  </div>
</div>
  );
}